export default "__VITE_ASSET__201dd9a9__"